<p class="mt-0 mb-3 grey-text">
  Ticket <strong>{{ ticketLabel }}</strong>
</p>

<!-- Nuova nota: solo se il ticket non è chiuso né annullato -->
<div
  class="mb-4"
  *ngIf="canAdd; else readOnly">
  <label for="new-note">Nuova nota</label>
  <textarea
    id="new-note"
    pInputTextarea
    class="w-full mt-1"
    rows="3"
    [maxlength]="maxNoteLength"
    placeholder="Scrivi una nota da sincronizzare con le integrazioni..."
    [formControl]="newNote"></textarea>
  <div class="flex justify-content-between align-items-center mt-2">
    <small class="grey-text">{{ newNote.value.length }} / {{ maxNoteLength }}</small>
    <p-button
      type="button"
      label="Aggiungi nota"
      icon="pi pi-plus"
      styleClass="butt"
      [rounded]="true"
      [loading]="saving"
      [disabled]="!newNote.value.trim() || newNote.invalid"
      (click)="addNote()"></p-button>
  </div>
</div>
<ng-template #readOnly>
  <p class="mb-4 grey-text">
    Non è possibile aggiungere note: il ticket è chiuso o annullato, o non hai i permessi per
    modificarlo.
  </p>
</ng-template>

<!-- Filtri -->
<form
  class="grid"
  [formGroup]="filters"
  (ngSubmit)="load()">
  <div class="col-12 md:col-3">
    <label for="filter-query">Testo</label>
    <input
      id="filter-query"
      type="text"
      pInputText
      class="w-full"
      placeholder="Cerca nella nota..."
      formControlName="query" />
  </div>
  <div class="col-12 md:col-3">
    <label for="filter-author">Autore</label>
    <input
      id="filter-author"
      type="text"
      pInputText
      class="w-full"
      placeholder="Nome, cognome o username"
      formControlName="author" />
  </div>
  <div class="col-12 md:col-2">
    <label>Sincronizzazione</label>
    <p-dropdown
      [options]="syncedOptions"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      appendTo="body"
      formControlName="synced"></p-dropdown>
  </div>
  <div class="col-12 md:col-3">
    <label>Create il</label>
    <p-calendar
      selectionMode="range"
      [firstDayOfWeek]="1"
      dateFormat="dd/mm/yy"
      styleClass="w-full"
      placeholder="Periodo"
      appendTo="body"
      [showIcon]="true"
      [readonlyInput]="true"
      formControlName="range"></p-calendar>
  </div>
  <div class="col-12 md:col-1 flex align-items-end">
    <p-button
      type="button"
      icon="pi pi-filter-slash"
      styleClass="butt w-full"
      pTooltip="Elimina filtri"
      tooltipPosition="top"
      [disabled]="!hasFilters"
      (click)="clearFilters()"></p-button>
  </div>
</form>

<!-- Elenco -->
<p-table
  [value]="notes"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  [loading]="loading"
  [paginator]="true"
  [rows]="rowsPerPage"
  [first]="first"
  [totalRecords]="total"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali"
  (onPage)="onPage($event)">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 11rem">Data</th>
      <th style="width: 12rem">Autore</th>
      <th>Nota</th>
      <th style="width: 13rem">Sincronizzazione</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-n>
    <tr>
      <td>{{ n.created_on | date: 'dd/MM/yyyy HH:mm' }}</td>
      <td>{{ authorName(n) }}</td>
      <td style="white-space: pre-wrap; word-break: break-word">{{ n.note }}</td>
      <td>
        <span *ngIf="n.from_hda" class="text-color-nes-blue">
          <i class="pi pi-arrow-circle-down mr-1"></i>
          Da integrazione
        </span>
        <span *ngIf="!n.from_hda && n.synced">
          <i class="pi pi-check-circle text-color-nes-teal mr-1"></i>
          Sincronizzata
          <small
            class="block grey-text"
            *ngIf="n.synced_on"
            >il {{ n.synced_on | date: 'dd/MM/yyyy HH:mm' }}</small
          >
        </span>
        <span
          *ngIf="!n.from_hda && !n.synced"
          class="grey-text">
          <i class="pi pi-clock mr-1"></i>
          Da sincronizzare
        </span>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td
        colspan="4"
        class="text-center py-3">
        {{ hasFilters ? 'Nessuna nota corrisponde ai filtri.' : 'Nessuna nota per questo ticket.' }}
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="modal-footer">
  <div class="flex justify-content-end">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
  </div>
</div>
